import { Navbar, Nav } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

import "./Header.css";

/* Landing-page navbar only — the customer-facing restaurant menu uses
   RestaurantHero.js instead (see App.js), which replaced the old
   single-row logo/name/language-switcher bar this component used to
   also render on restaurant subdomains. */
function Header() {
  const location = useLocation();

  return (
    <header>
      <Navbar className="app-navbar app-header-dark" variant="dark">
        <div className="navbar-inner">
          <Navbar.Brand as={Link} to={`/${location.search}`} className="navbar-brand-logo">
            <img src="/static/images/tablifylogo.png" alt="Tablify" height="40" />
          </Navbar.Brand>

          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/#features" className="landing-nav-link">
              Funkciók
            </Nav.Link>
            <Nav.Link as={Link} to="/#pricing" className="landing-nav-link">
              Árazás
            </Nav.Link>
            <Nav.Link
              href="https://teszt-etterem.tablify.hu"
              className="landing-nav-link"
            >
              Demó
            </Nav.Link>
            <Nav.Link as={Link} to="/about" className="landing-nav-link">
              Rólunk
            </Nav.Link>
            <Nav.Link
              href="https://app.tablify.hu/register"
              className="landing-nav-cta"
            >
              Ingyenes Kipróbálás
            </Nav.Link>
            <Nav.Link href="https://app.tablify.hu/login">
              <FaUserCircle size={22} style={{ marginRight: 6 }} />
            </Nav.Link>
          </Nav>
        </div>
      </Navbar>
    </header>
  );
}

export default Header;
